import React, { forwardRef } from 'react'
import { FieldTypes } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import VeracodeMappingForm from './VeracodeMappingForm';

function VeracodeCredentialsForm(props, ref){

    const fields = [
        {
            name: "accessKey",
            label: "Access Key",
            required: true,
        },
        {
            name: "secretKey",
            label: "Secret Key",
            required: true,
            type: FieldTypes.PASSWORD,
        }
    ];
    
    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            versionField={false}
            MappingForm={VeracodeMappingForm}
        />
    )
}

export default forwardRef(VeracodeCredentialsForm);